





























































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator';
import { RobotOption, TwitterCardOption } from '@/models/MetaTags';
import { getLocalesString } from '@/models/Locale';

import { BusyList, BusyObject } from '@/models/Busy';
import { Monitoring, MonitoringsService } from '@/api/braendz';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import MonitoringCard from '@/components/Monitoring/MonitoringCard.vue';
import Popup from '@/components/Popups/Popup.vue';
import BrandPicker from '@/components/Brands/BrandPicker.vue';
import DashboardCard from '@/components/Dashboard/DashboardCard.vue';
import { AccountInfo } from '@azure/msal-browser';

@Component({
  components: {
    LoadingView,
    MonitoringCard,
    BrandPicker,
    Popup,
    DashboardCard
  },
  metaInfo() {
    return {
      title: this.$i18n.t("monitorBrand.title").toString(),
      meta: [
        { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') },

        // Open Graph: Facebook, Instagram, WhatsApp, LinkedIn, Xing, Twitter:
        { property: 'og:type', content: "website" },
        { property: 'og:title', content: this.$i18n.t("monitorBrand.metaTags.title").toString() },
        { property: 'og:description', content: this.$i18n.t("monitorBrand.metaTags.description").toString() },
        { property: 'og:image', content: `${window.location.origin}${require('@/assets/logos/braendz-logo-tm-blue.png')}` },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:locale:alternate', content: getLocalesString(',') },
        { property: 'og:site_name', content: this.$i18n.t("metaTags.title").toString()},

        // Twitter:
        { property: 'twitter:card', content: TwitterCardOption.SummaryLargeImage },
        { property: 'twitter:site', content: `@${process.env.VUE_APP_TWITTER_ACCOUNT}` }
      ]
    };
  }
})
export default class Overview extends Vue {
    // Private Members:

    // Public Fields:
    public monitorings = new BusyList<Monitoring>();

    // Getter:
    public get isInitializing(): boolean {
        return this.$store.state.activeSubscription.isBusy
            || this.monitorings.isBusy;
    }

    public get userAccount(): AccountInfo | null {
        return this.$store.state.userAccount;
    }

    // Watchers & Event Handlers:

    // Component Lifecycle
    public mounted() {
        this.initMonitorings();
    }

    // Methods
    public async initMonitorings() {
        if(!this.userAccount) {
            return;
        }

        await this.monitorings.load(async () => {
            return await MonitoringsService.getMonitoringsCurrentUserDefaultAccount();
        });
    }
    public async removeMonitoring(monitoring: Monitoring) {
        await this.monitorings.delete(async () => {
            if (!monitoring.id) {
                return null;
            }
            await MonitoringsService.deleteMonitoring(monitoring.id);
            return monitoring;
        });
    }
}
